import React from 'react';
import { motion } from 'framer-motion';
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './notes-app.css';
import notesAppImg from '../../../assets/images/Pk Notes App.png';
import qrCodeImg from '../../../assets/images/PK-Notes-App.png';

const PKNotesApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        PK <span>Notes</span> – Fully Modern Secure Notes Platform 🚀
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 05 April 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={notesAppImg} alt="PK Notes App" className="project-image" />
          <h2 className="project-subtitle">PK Notes App</h2>
          <span className="project-category">Software Applications</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="notesApp" trackView={true} />

          <div className="project-buttons">
            <a
              href="https://pk-notesapp.web.app/"
              className="visit-project-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              → Visit the Project
            </a>
            <a
              href="https://github.com/Praveenkumar-king"
              className="visit-project-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "notesApp",
                title: "PK Notes App",
                path: "/projects/projectdetail/notes-app"
              }}
            />
          </div>

          <div className="qr-container">
            <img src={qrCodeImg} alt="QR Code" className="qr-image" />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Overview ✨</h3>
          <p className="overview-description">
            <strong>PK Notes</strong> is a fully modern, secure, and scalable notes management platform built using the MERN stack. 
            It is designed with real-world SaaS architecture, focusing on <strong>security, performance, and user experience</strong>. 
            The platform enables users to create, manage, and protect their notes with advanced features like encryption, authentication, and subscription-based access. 🔐🚀
          </p>

          <h3 className="section-title">Key Features 🛠️</h3>
          <ul className="feature-list">
            <li>User Authentication 🔐 – Secure signup/login with JWT authentication & protected routes.</li>
            <li>Create, Edit & Delete Notes ✏️ – Full CRUD operations with real-time updates.</li>
            <li>Note Locking 🔒 – Protect sensitive notes using AES encryption with password security.</li>
            <li>Pin Important Notes 📌 – Highlight and prioritize important notes.</li>
            <li>Password Reset System 📧 – Email-based reset + OTP-based secure password change.</li>
            <li>Dark & Light Mode 🌙☀️ – Modern UI theme toggle with persistent user preference.</li>
            <li>Secure APIs 🛡️ – Backend protected with authentication middleware.</li>
            <li>Responsive UI 📱💻 – Optimized across mobile, tablet, and desktop devices.</li>
            <li>Subscription System 💳 – Razorpay integration with secure payment flow.</li>
            <li>Real-time Email Notifications 📩 – Payment success, subscription activation, and security alerts.</li>
            <li>
              Advanced Note Sharing 🔗 – Share notes via secure links with support for 
              <strong> private access</strong>, 
              <strong> public access</strong>, and 
              <strong> password-protected mode</strong>. 
              Includes <strong>custom expiration control</strong> for enhanced security.
            </li>
          </ul>

          <h3 className="section-title">Advanced Features 🚀</h3>
          <ul className="feature-list">
            <li>🔐 AES Encryption for locked notes</li>
            <li>📨 Email verification & welcome system</li>
            <li>🔁 Refresh token authentication system</li>
            <li>📊 Subscription & transaction tracking</li>
            <li>🎟️ Ticket-based support system</li>
            <li>🤖 AI integration In Dashboard</li>
            <li>🤖 AI Chatbot integration (Help Center)</li>
          </ul>


          <h3 className="section-title">Why PK Notes? 🤔</h3>
          <ul className="how-it-works-list">
            <li>💼 Industry-level full-stack architecture</li>
            <li>🔐 High-level security implementation</li>
            <li>⚡ Smooth and modern UI/UX</li>
            <li>📈 Scalable SaaS-ready system</li>
            <li>🎯 Perfect portfolio project for developers</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>
            <strong>PK Notes</strong> is not just a notes app — it's a complete SaaS product demonstrating 
            real-world development skills, secure architecture, and modern design principles. 
            It showcases the ability to build scalable, production-ready applications. 🚀🔥
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default PKNotesApp;